/**
 * Section : Hero Homepage — FOG Theme
 * Comportement :
 *  - Affiche la video des qu'elle est prete (decouple du chargement des fonts)
 *  - L'entree du texte est en CSS pur (section-hero-homepage.css, 14/10/2026) :
 *    elle n'attend plus ce script, execute seulement a DOMContentLoaded
 *  - La pause hors ecran des animations decoratives est dans global.js ; celle
 *    de la video est ici (initPauseHorsEcran)
 */

(function () {
  'use strict';

  function initHeroEntrance() {
    var hero = document.querySelector('.hero-homepage');
    if (!hero) return;

    var video = hero.querySelector('.hero-homepage__video-bg video');

    // 1. Video : afficher des qu'elle peut jouer (independant des fonts)
    if (video) {
      var videoRevealed = false;
      var revealVideo = function () {
        if (videoRevealed) return;
        videoRevealed = true;
        hero.classList.add('hero-video-ready');
      };

      // Video de fond pilotee par video-lazy.js (data-video-desktop) : elle peut ne
      // jamais recevoir de source (reduced-motion, economie de donnees, mobile sans
      // data-video-mobile-src). Il ne faut alors pas la reveler, sinon une balise
      // vide vient recouvrir le poster affiche en fond.
      var reserveeDesktop = video.hasAttribute('data-video-desktop');

      // Une video en autoplay n'est revelee que lorsqu'elle JOUE reellement, et non
      // des qu'elle est chargee. Constate le 4 septembre 2026 sur iPhone en mode
      // economie d'energie : iOS refuse alors l'autoplay, et sur 'loadeddata' on
      // revelait une video figee sur son premier frame, surmontee du bouton de
      // lecture natif de Safari, lui-meme inerte a cause du pointer-events: none
      // du conteneur. En ecoutant 'playing', une lecture refusee laisse simplement
      // le poster en place : c'est la meme degradation propre que pour
      // prefers-reduced-motion. video-lazy.js rearme une tentative au premier geste
      // du visiteur, un play() declenche par une interaction restant autorise.
      var autoplay = video.hasAttribute('autoplay');

      if (autoplay) {
        if (!video.paused && video.readyState >= 3) {
          revealVideo();
        } else {
          video.addEventListener('playing', revealVideo, { once: true });
        }
        initPauseHorsEcran(hero, video);
      } else if (video.readyState >= 2) {
        // Deja en cache / pret
        revealVideo();
      } else {
        video.addEventListener('loadeddata', revealVideo, { once: true });
        video.addEventListener('canplay', revealVideo, { once: true });
        // Fallback : ne pas bloquer indefiniment si l'event ne fire pas.
        // Ecarte pour une video reservee au desktop : l'absence d'evenement y est
        // le fonctionnement normal (mobile), pas un chargement qui traine.
        if (!reserveeDesktop) setTimeout(revealVideo, 1500);
      }
    } else {
      hero.classList.add('hero-video-ready');
    }
  }

  /**
   * Pause de la video quand le hero quitte l'ecran, reprise a son retour
   * (constat B1 de la relecture du 14/10/2026 : elle tournait toute la visite,
   * ~15 a 20 % d'un coeur en desktop). Trois gardes, issues de la verification :
   *  - un demarrage tardif (chargement apres le LCP, relance au geste de
   *    video-lazy.js) peut survenir alors que le visiteur est deja descendu :
   *    l'ecouteur 'playing' remet alors en pause ;
   *  - jamais de play() sans currentSrc : avant que video-lazy.js ait pose la
   *    source, il lancerait la selection sur les <source data-src> ;
   *  - iOS en economie d'energie peut refuser la reprise hors geste : la video
   *    resterait figee sur une image (cas du 4 septembre). Le poster revient
   *    alors en fondu, et la lecture est retentee au geste suivant dans le hero.
   */
  function initPauseHorsEcran(hero, video) {
    if (!('IntersectionObserver' in window)) return;
    var intro = hero.querySelector('.hero-homepage__intro') || hero;
    var visible = true;
    var enPauseParNous = false;
    var relanceArmee = false;

    function relancerAuGeste() {
      if (relanceArmee) return;
      relanceArmee = true;
      var evenements = ['touchend', 'click', 'keydown', 'scroll'];
      function retirer() {
        relanceArmee = false;
        for (var i = 0; i < evenements.length; i++) {
          document.removeEventListener(evenements[i], tenter);
        }
      }
      function tenter() {
        if (!visible) return;
        var p = video.play();
        if (p && typeof p.then === 'function') {
          p.then(function () {
            hero.classList.add('hero-video-ready');
            retirer();
          }, function () {});
        }
      }
      for (var i = 0; i < evenements.length; i++) {
        document.addEventListener(evenements[i], tenter, { passive: true });
      }
    }

    new IntersectionObserver(function (entries) {
      visible = entries[entries.length - 1].isIntersecting;
      if (!video.currentSrc) return;
      if (!visible) {
        if (!video.paused) {
          video.pause();
          enPauseParNous = true;
        }
      } else if (enPauseParNous) {
        enPauseParNous = false;
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            hero.classList.remove('hero-video-ready');
            relancerAuGeste();
          });
        }
      }
    }).observe(intro);

    video.addEventListener('playing', function () {
      if (!visible) {
        video.pause();
        enPauseParNous = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroEntrance);
  } else {
    initHeroEntrance();
  }
})();
